import useGlobalDialog from './useGlobalDialog';

export interface useAddAdvertMediaDialogProps {
  advertId?: string;
}

const useAddAdvertMediaDialog = () =>
  useGlobalDialog<useAddAdvertMediaDialogProps>('addAdvertMedia');
export default useAddAdvertMediaDialog;
